import React, { useEffect, useState, useContext, useLayoutEffect, useCallback } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'


import $ from 'jquery';
import { AppColors } from '../css/AppColors';
import { apiRequest } from '../utils/apiCalls';
import { Modal, Button } from 'react-bootstrap';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { FaClipboardList, FaPencilAlt, FaTrash } from 'react-icons/fa'
import { Link } from 'react-router-dom';
import promotionImg from '../img/promotionImg.png';


const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return React.useCallback(() => updateState({}), []);
}



const ViewProducts = (props) => {

    const { state, setCustomersGlobal, setProductsGlobal } = useContext(Context)
    const forceUpdate = useForceUpdate();
    const [loading, setLoading] = useState(false)
    const [prod, setProd] = useState(state.products ? state.products : []);
    const [val, setVal] = useState(0)
    const [delProdId, setDelProdId] = useState('')
    const [delProdModal, setDelProdModal] = useState(false)

    useEffect(() => {
        $(document).ready(function () {
            {
                $('#dataTable')
                    .DataTable({
                        language: {
                            emptyTable: "No product found.",
                            zeroRecords: "No product matches your search."
                        },
                        "order": [[0, "desc"]]
                    })

            }
        });
        //     $('#dataTable').DataTable();
        // });
    }, [loading])

    useEffect(() => {
        if (!state.products.length) {
            getProducts()
        }

        if (props.location?.state?.refresh) {
            if (props.location?.state?.products) {
                setProd(props.location.state.products)
                forceUpdate();
                return
            }
            getProducts()
        }
    }, [])



    function getProducts() {

        setLoading(true)
        apiRequest({ st_id: state.storeData.st_id }, 'viewprod')
            .then(data => {

                if (data.status == '1') {
                    setProd(data.data)
                    setProductsGlobal(data.data)
                    setLoading(false)
                }
                else {
                    // alert(data.error)
                    setLoading(false)
                }
            })
            .catch(err => {
                setLoading(false)
                alert('Network error')
                console.log(err)
            })
    }

    function formatExpiry(expiry) {
        if (expiry == '1') return 'Daily'
        if (expiry == '7') return 'Weekly'
        if (expiry == '14') return 'Bi-Weekly'
        if (expiry == '30') return 'Monthly'
        else return expiry

    }

    function delProd() {
        setLoading(true)
        const reqObj = {
            p_id: delProdId
        }
        console.log(reqObj)
        apiRequest(reqObj, 'delprod')
            .then(data => {
                setLoading(false)
                if (data.status == '1') {
                    setLoading(false)
                    getProducts();
                    alert('Product Deleted')

                }
                else alert(data.error)
            })
            .catch(err => {
                setLoading(false)
                alert('Internet Error')
            })
    }




    return (
        <div>
            <div id="wrapper">
                <Sidebar />
                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">
                    <Topbar />

                    {/* Main Content */}
                    <div id="content">

                        <Modal
                            show={delProdModal}
                            onHide={() => setDelProdModal(false)}
                        >
                            <Modal.Header>
                                <Modal.Title style={{ fontSize: 18, textAlign: 'center', alignSelf: 'center' }} >Are you sure you want to delete this product?{"\n"}Deleting products will delete all the related product promotions.</Modal.Title>
                            </Modal.Header>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => {
                                    setDelProdId('')
                                    setDelProdModal(false)
                                }}>No</Button>
                                <Button variant="danger" onClick={() => {
                                    setDelProdModal(false)
                                    delProd()
                                }}>Yes</Button>
                            </Modal.Footer>


                        </Modal>


                        <Modal
                            show={loading}
                        >

                            <Modal.Body class="text-center" >
                                <div
                                    class="text-center"
                                    class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                            </Modal.Body>

                        </Modal>
                        {/* Begin Page Content */}
                        <div className="container-fluid">
                            {/* Page Heading */}
                            <div className="container-fluid">
                                {/* Page Heading */}
                                <div style={{ width: "100%", height: 65 }}>
                                    <div style={{ float: "left", width: "50%" }}>
                                        <h1 className="h3 mb-2 text-gray-800">View Products</h1>
                                        <br />
                                    </div>
                                    <Button
                                        className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
                                        style={{ color: 'white', backgroundColor: AppColors.primary, borderWidth: 0, fontFamily: 'RBo', float: "right", }}
                                    >
                                        <Link
                                            style={{ color: 'white' }}
                                            to="/addProduct">
                                            Add Product
                                        </Link>
                                    </Button>
                                </div>
                                {/* DataTales Example */}
                                <div className="card shadow mb-4" style={{ width: "100%" }} >
                                    <div className="card-body">
                                        {
                                            !loading &&

                                            <div className="table-responsive">
                                                {/* table class="table table-bordered dt-responsive" id="dataTable" width="100%" cellspacing="0" */}
                                                <table
                                                    id="dataTable"
                                                    className="table table-striped table-bordered dt-responsive"
                                                    style={{ width: "100%" }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th hidden={true} className="tRow">Id</th>
                                                            <th className="tRow">Name</th>
                                                            <th className="tRow">MSRP</th>
                                                            <th className="tRow">Type</th>
                                                            <th className="tRow">Age</th>
                                                            <th className="tRow">Status</th>
                                                            <th className="tRow">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            prod.map((v) => {
                                                                return (
                                                                    <tr>
                                                                        <td hidden={true} className="tData"><nobr>{v.p_id}</nobr></td>
                                                                        <td className="tData"><nobr>{v.p_name}</nobr></td>
                                                                        <td className="tData"><nobr>{v.p_MSRP}</nobr></td>
                                                                        {/* <td className="tData"><nobr>{v.p_expiry}</nobr></td> */}
                                                                        <td className="tData"><nobr>{v.p_type}</nobr></td>
                                                                        <td className="tData"><nobr>{formatExpiry(v.p_age)}</nobr></td>
                                                                        <td className="tData"><nobr>{v.p_status == '1' ? "Active" : "Inactive"}</nobr></td>
                                                                        <td>
                                                                            <Link to=
                                                                                {{
                                                                                    pathname: '/ViewSingleProd',
                                                                                    state: v
                                                                                }}
                                                                                className="btn" style={{ backgroundColor: '#54C2BB' }} >
                                                                                <FaClipboardList color="white" />
                                                                            </Link>{" "}

                                                                            <Link to={{
                                                                                pathname: "/editProduct",
                                                                                state: v
                                                                            }}
                                                                                className="btn" style={{ backgroundColor: '#54C2BB' }} >
                                                                                <FaPencilAlt color="white" />
                                                                            </Link>{" "}
                                                                            <Button
                                                                                onClick={() => {
                                                                                    setDelProdId(v.p_id)
                                                                                    setDelProdModal(true)
                                                                                }} className="btn btn-danger del_product" id>
                                                                                <FaTrash color="white" />
                                                                            </Button>
                                                                            <Button
                                                                                onClick={() => {

                                                                                    // setDelProdId(v.p_id)
                                                                                    // setDelProdModal(true)
                                                                                }}
                                                                                className="btn rBBtn "
                                                                                style={{ width: 50, background: 'none', borderWidth: 0 }}
                                                                            >
                                                                                <Link to={{
                                                                                    // pathname: "/addPromotion",
                                                                                    pathname: "/managePromotion",
                                                                                    state: v
                                                                                }}
                                                                                >
                                                                                    <img src={promotionImg} style={{ width: 35, borderRadius: 8 }} />
                                                                                </Link>
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }

                                                    </tbody>

                                                    <tbody>
                                                        {/*?php 	/*$lst_vehicles = $arr_response["lst_vehicles"];
		for($i = 0; $i < sizeof($lst_vehicles); $i++){ ?*/}
                                                        <tr>
                                                            <td>
                                                                <nobr>
                                                                    {/*?php print($lst_vehicles[$i]["v_no"]); ?*/}
                                                                </nobr>
                                                            </td>
                                                            <td>
                                                                <nobr>
                                                                    {/*?php print($lst_vehicles[$i]["v_make"]); ?*/}
                                                                </nobr>
                                                            </td>
                                                            <td>
                                                                <nobr>
                                                                    {/*?php print($lst_vehicles[$i]["v_model"]); ?*/}
                                                                </nobr>
                                                            </td>
                                                            <td>
                                                                {/*?php print($lst_vehicles[$i]["v_own_name"]); ?*/}
                                                            </td>
                                                            <td>
                                                                {/*?php print($lst_vehicles[$i]["v_own_phone"]); ?*/}
                                                            </td>
                                                            <td>
                                                                {/*?php print($lst_vehicles[$i]["v_expiry"]); ?*/}
                                                            </td>
                                                        </tr>
                                                        {/*?php 	} * /?*/}
                                                    </tbody>
                                                </table>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /.container-fluid */}
                    </div>
                    {/* End of Main Content */}
                </div>
                {/* End of Content Wrapper */}
            </div>

            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up" />
            </a>
            {/* Logout Modal*/}
            <div
                className="modal fade"
                id="logoutModal"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Ready to Leave?
                            </h5>
                            <button
                                className="close"
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Select "Logout" below if you are ready to end your current session.
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-secondary"
                                type="button"
                                data-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <a className="btn btn-primary" href="logout.php">
                                Logout
                            </a>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    )
}

export default ViewProducts
